import { EmptyCard, LoadingBlock, PageHeader } from '@/components/PageHeader';

import { useSiteTbm } from './siteSafeApi';

/** 현장 › 협력사 TBM — 협력사 포털에서 연 TBM 과 서명 수(읽기만). 직원이 쓰는 TBM 일지는 일지 종류 TBM(V572). */
export function SiteTbmPage({ siteId }: { siteId: string }) {
  const tbm = useSiteTbm(siteId);
  const rows = tbm.data ?? [];

  return (
    <div className="space-y-5">
      <PageHeader title="협력사 TBM" />
      {tbm.isPending ? (
        <LoadingBlock />
      ) : tbm.isError ? (
        <LoadingBlock />
      ) : rows.length === 0 ? (
        <EmptyCard>TBM 기록이 없습니다.</EmptyCard>
      ) : (
        <div className="card p-0" style={{ overflowX: 'auto' }}>
          <table className="site-table">
            <thead>
              <tr>
                <th style={{ width: '120px' }}>일자</th>
                <th style={{ textAlign: 'left' }}>작업 내용</th>
                <th style={{ textAlign: 'left' }}>위험요인</th>
                <th style={{ width: '110px' }}>서명</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>{row.tbmDate}</td>
                  <td style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>{row.workSummary ?? '—'}</td>
                  <td style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>{row.hazards ?? '—'}</td>
                  <td style={{ fontWeight: 600, color: row.signedCount < row.requiredCount ? '#b45309' : undefined }}>
                    {row.signedCount}/{row.requiredCount}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
